import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#dadada',
        secondary: '#6fac46',
        accent: '#5b9bd4',
        error: '#ff0000',
        info: '#6e2e9f',
        success: '#363532',
        warning: '#f0b502'
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
